/*
  LadyCloshop — hojas que suben desde abajo (compra en la ficha y compra rápida): se cierran
  deslizando el dedo hacia abajo, como en una app.

  - Se puede arrastrar desde la cabecera o desde cualquier punto si la hoja está arriba del todo
    (si no, el dedo desplaza el contenido, como siempre).
  - La hoja sigue al dedo; al soltar se cierra solo si se ha bajado más de la mitad de su altura;
    si no, vuelve a su sitio con suavidad.
  - Usa la propiedad «translate», que se suma al «transform» de la hoja (la animación de abrir y
    cerrar sigue siendo la misma).

  Uso: lcSheetDrag(hoja, () => cerrar());
*/
window.lcSheetDrag = function (sheet, close) {
  if (!sheet || sheet.dataset.lcDrag === 'true') return;
  sheet.dataset.lcDrag = 'true';
  let drag = null;

  const reset = () => {
    sheet.classList.remove('lc-sheet-dragging');
    sheet.style.translate = '';
  };

  sheet.addEventListener(
    'touchstart',
    (event) => {
      if (!sheet.classList.contains('is-open') || event.touches.length > 1) return;
      const fromHead = !!event.target.closest('.lc-buy-group__head');
      if (!fromHead && sheet.scrollTop > 0) return;
      const touch = event.touches[0];
      drag = { x: touch.clientX, y: touch.clientY, dy: 0, on: false };
    },
    { passive: true }
  );

  sheet.addEventListener(
    'touchmove',
    (event) => {
      if (!drag) return;
      const touch = event.touches[0];
      const dx = touch.clientX - drag.x;
      const dy = touch.clientY - drag.y;
      if (!drag.on) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        // Solo hacia abajo y en vertical; con la hoja desplazada, manda el desplazamiento
        if (dy < 0 || Math.abs(dx) > Math.abs(dy) || sheet.scrollTop > 0) {
          drag = null;
          return;
        }
        drag.on = true;
        drag.y = touch.clientY;
        sheet.classList.add('lc-sheet-dragging');
      }
      event.preventDefault();
      drag.dy = Math.max(0, touch.clientY - drag.y);
      sheet.style.translate = `0 ${drag.dy}px`;
    },
    { passive: false }
  );

  const end = () => {
    if (!drag) return;
    const { dy, on } = drag;
    drag = null;
    if (!on) return;
    // Al quitar el arrastre, «translate» vuelve a 0 y «transform» baja la hoja a la vez:
    // el movimiento sigue desde donde quedó el dedo, sin salto
    reset();
    if (dy > sheet.offsetHeight * 0.5) close();
  };
  sheet.addEventListener('touchend', end);
  sheet.addEventListener('touchcancel', end);
};
